// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fl","advertDetailContacts__header":"c-m_fm"};